import classNames from "classnames";
import React from "react";

import { WSAvatar, WSAvatarProps, WSPill, WSPillProps } from "../common";
import { WSIcon, WSIconName } from "../core/WSIcon/WSIcon.component";
import { WSText } from "../core/WSText/WSText.component";
import {
  WSElement,
  WSElementColorsType
} from "../WSElement/WSElement.component";
import {
  WSTooltipIcon,
  WSTooltipIconProps
} from "../WSTooltipIcon/WSTooltipIcon";

import styles from "./WSTableCell.module.scss";

export type WSTableCellProps = {
  text?: React.ReactNode;
  secondaryText?: React.ReactNode;
  secondaryTextColor?: WSElementColorsType;
  disabled?: boolean;
  icon?: WSIconName;
  avatar?: WSAvatarProps;
  rightAvatar?: WSAvatarProps;
  pill?: WSPillProps;
  truncationOptions?: {
    text?: {
      allowTwoLines?: boolean;
    };
  };
  onClick?: React.MouseEventHandler<HTMLElement>;
  tooltip?: WSTooltipIconProps["tooltip"];
};

export const WSTableCell: React.FC<WSTableCellProps> = (props) => {
  const allowTwoLines = props.truncationOptions?.text?.allowTwoLines ?? true;

  if (
    !props.text &&
    !props.secondaryText &&
    !props.icon &&
    !props.avatar &&
    !props.pill
  ) {
    return (
      <WSElement className={styles.tableCell} onClick={props.onClick}>
        <WSText.ParagraphSm>–</WSText.ParagraphSm>
      </WSElement>
    );
  }

  const textElement = props.text && (
    <WSText.ParagraphSm
      className={classNames(styles.text, allowTwoLines && styles.twoLines)}
    >
      {props.text}
    </WSText.ParagraphSm>
  );
  const secondaryTextElement = props.secondaryText && (
    <WSText.ParagraphXs
      className={classNames(styles.secondaryText, styles.twoLines)}
      color={props.secondaryTextColor || "gray400"}
    >
      {props.secondaryText}
    </WSText.ParagraphXs>
  );
  const iconElement = props.icon && (
    <WSIcon name={props.icon} size="M" color="gray500" />
  );
  const avatarElement = props.avatar && <WSAvatar {...props.avatar} size="S" />;
  const rightAvatarElement = props.rightAvatar && (
    <WSAvatar className={styles.rightAvatar} {...props.rightAvatar} size="S" />
  );
  const pillElement = props.pill && (
    <WSPill {...props.pill} truncate className={styles.pill} />
  );

  const tooltipElement = props.tooltip ? (
    <WSTooltipIcon tooltip={props.tooltip} />
  ) : undefined;

  return (
    <WSElement
      className={classNames(
        styles.tableCell,
        props.disabled && styles.disabled
      )}
      onClick={props.onClick}
    >
      {props.avatar ? avatarElement : props.icon ? iconElement : null}
      <WSElement className={styles.main}>
        {pillElement}
        {textElement}
        {secondaryTextElement}
      </WSElement>
      {props.avatar && props.icon ? iconElement : null}
      {props.rightAvatar ? rightAvatarElement : null}
      {tooltipElement}
    </WSElement>
  );
};
